const ActionTypes = {
    SET_MAP : 'SET_MAP',
    MENU_TOGGLE : 'MENU_TOGGLE',
    MAP_STYLE : 'MAP_STYLE',
    SEARCH : 'SEARCH',
    SET_FILTER: 'SET_FILTER',
    SET_CATEGORY: 'SET_CATEGORY',
    SET_ACTIVE_FILTER : 'SET_ACTIVE_FILTER',
    MAP_LOADED : 'MAP_LOADED',
    MAP_DIRECTION : 'MAP_DIRECTION',
    LOCATION_LIST : 'LOCATION_LIST'
}
export default ActionTypes; 


// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js